import './App.css'
import { GameCanvas as BaseGameCanvas } from '@sencerburak/game-of-life'

function App() {
  console.log('App')

  const canvasContainerStyle: React.CSSProperties = {
    backgroundColor: 'black',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
  }

  const desiredCellSize = 20 // Change this as needed

  // Calculate the number of cells that can fit in the viewport
  const gridWidth = Math.floor(window.innerWidth / desiredCellSize)
  const gridHeight = Math.floor(window.innerHeight / desiredCellSize)

  const centeredStyle: React.CSSProperties = {
    display: 'flex', // use Flexbox
    justifyContent: 'center', // center horizontally
    alignItems: 'center', // center vertically
    position: 'absolute', // absolute positioning
    top: 0, // position from the top
    left: 0, // position from the left
    width: '100%', // take up the full width of the parent
    height: '100%', // take up the full height of the parent
  }

  const desiredInnerGridCellSize = 1 // Change this as needed
  const innerGridWidth = Math.floor(window.innerWidth / desiredInnerGridCellSize / 1.5)
  const innerGridHeight =
    Math.floor(innerGridWidth * 1.618) > Math.floor(window.innerHeight / desiredInnerGridCellSize)
      ? Math.floor((window.innerHeight / desiredInnerGridCellSize) * 0.8)
      : Math.floor(innerGridWidth * 1.618)

  type ColorName = 'lightblue' | 'darkorange' | 'darkblue' | 'red' | 'yellowgreen' | 'navajowhite' | 'steelblue'

  function toRGBA(color: ColorName, alpha = 0.95): string {
    const colorMap: Record<ColorName, string> = {
      lightblue: '173,216,230',
      darkorange: '255,140,0',
      darkblue: '0,0,139',
      red: '255,0,0',
      yellowgreen: '154,205,50',
      navajowhite: '255,222,173',
      steelblue: '70,130,180',
    }

    return `rgba(${colorMap[color]}, ${alpha})`
  }

  const complementaryColors = [
    { primary: 'lightblue', complement: toRGBA('darkorange') },
    { primary: 'darkorange', complement: toRGBA('darkblue') },
    { primary: 'red', complement: toRGBA('darkblue') },
    { primary: 'yellowgreen', complement: toRGBA('red') },
    { primary: 'navajowhite', complement: toRGBA('steelblue') },
  ]

  function getRandomColorPair(): { primary: string; complement: string } {
    const randomIndex = Math.floor(Math.random() * complementaryColors.length)
    return complementaryColors[randomIndex]
  }

  const randomColorPair = getRandomColorPair()

  const fancyFrameStyle: React.CSSProperties = {
    border: `10px double ${randomColorPair.primary}`, // This creates a fancy double border
    borderRadius: '10px', // This makes the corners rounded
    boxShadow: '5px 5px 15px rgba(0,0,0,0.3)', // This adds a shadow for a 3D effect
    padding: '5px', // This creates some space between the frame and the component
    display: 'inline-block', // This makes sure the frame fits the content
  }

  function WithFancyFrame(Component: React.ComponentType<any>) {
    return function WrappedComponent(props: any) {
      return (
        <div style={fancyFrameStyle}>
          <Component {...props} />
        </div>
      )
    }
  }

  const GameCanvas = WithFancyFrame(BaseGameCanvas)

  return (
    <div className='app' style={canvasContainerStyle}>
      <div style={canvasContainerStyle}>
        <BaseGameCanvas
          // componentWidth=gridWidth * desiredCellSize
          // componentHeight=gridHeight * desiredCellSize
          gridWidth={gridWidth}
          gridHeight={gridHeight}
          cellSize={desiredCellSize}
          maxFps={2}
          debug={false}
          activeCellColor='dimgrey'
          inactiveCellColor='black'
        />
      </div>
      <div style={centeredStyle}>
        <GameCanvas
          gridWidth={innerGridWidth}
          gridHeight={innerGridHeight}
          cellSize={desiredInnerGridCellSize}
          maxFps={30} // Change this as needed
          debug={true} // Disable this in production, or not if you want to see debug info
          activeCellColor={randomColorPair.primary}
          inactiveCellColor={randomColorPair.complement}
          debugColor={randomColorPair.primary}
        />
      </div>
    </div>
  )
}

export default App
